import React from 'react'
import cx from 'classnames'
import { xor, includes, sortBy, find } from 'libraries/lodash'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import Checkbox from 'components/dealwatch/Checkbox'
import FilterComponent from './FilterComponent'

const CUTOFF = 5

export default class RestrictingValuesFilter extends FilterComponent {
  state = {
    expanded: false
  }

  handleToggleExpand = (expanded = false) => () => this.setState({ expanded })

  renderValue = ({ value, displayName: label }) => {
    const checked = includes(this.value, value)
    const { column = true } = this.props

    return (
      <div key={value} className={cx('overflow-hidden', { mh6: !column })}>
        <Checkbox
          {...{ checked, label }}
          onClick={this.handleChange(value)}
        />
      </div>
    )
  }

  handleChange = (value) => (e) => {
    this.props.setFilterValue([
      [
        xor(this.value, [value]),
        '='
      ]
    ])
  }

  get restrictingValues () {
    const findUK = (compare) => ({ displayName }) => (displayName.replace(/\s/g, '') === 'UnitedKingdom') === compare
    const UK = find(this.props.restrictingValues, findUK(true))
    return [UK, ...sortBy(this.props.restrictingValues.filter(findUK(false)), 'displayName')].filter(x => !!x)
  }

  get values () {
    const selected = this.value
    return this.props.basicDisplay && !this.state.expanded
      ? this.value.length > 0 && this.restrictingValues.length > CUTOFF
        ? [...this.restrictingValues].filter(({ value }) => includes(selected, value))
        : [...this.restrictingValues].slice(0, 5)
      : this.restrictingValues
  }

  get length () {
    return this.restrictingValues.length
  }

  render () {
    const { values, length, props: { column = true } } = this
    const selected = this.value

    return (
      <div>
        <div className={cx({
          'pa0 db': column,
          'flex flex-wrap items-start pv6 ph0': !column
        })}
        >
          {values.map(this.renderValue)}
        </div>
        <Expander
          expanded={values.length === length}
          onChange={this.handleToggleExpand}
          howMany={length - values.length}
          show={length > CUTOFF && selected.length < length && this.props.basicDisplay}
        />
      </div>
    )
  }
}

const Expander = ({ expanded, onChange, show, howMany }) => !show
  ? null
  : (
    <div className='f7 ml7 mt2 hover-underline'>
      {!expanded && (
        <a className='flex items-center pointer' href={null} onClick={onChange(true)}>
          <span className='cadet-blue ml2'>see {howMany} more</span>
          <ArrowDropDownIcon htmlColor='black' />
        </a>
      )}
      {expanded && (
        <a className='flex items-center pointer' href={null} onClick={onChange(false)}>
          <span className='cadet-blue ml2'>collapse</span>
          <ArrowDropUpIcon htmlColor='black' />
        </a>
      )}
    </div>
    )
